import * as React from 'react';
import { SVGProps } from 'react';

const IconFlagFilledSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M21 2H3v20h2v-6h16l-3-7 3-7z" />
  </svg>
);
export default IconFlagFilledSizeM;
